const areaList = state => state.areaList
const areaTematicaList = state => state.areaTematicaList
const areaRiservataEnumList = state => state.areaRiservataEnumList
const regioneList = state => state.regioneList
const trainingCourseTypesList = state => state.trainingCourseTypesList

export default {
  areaList,
  areaTematicaList,
  areaRiservataEnumList,
  regioneList,
  trainingCourseTypesList,
}
